module.exports = __webpack_public_path__ + "../resources/img/pv_cal_intro_img.a832b1d9.png";